'use client';

import { __rest, __assign } from '../_virtual/_tslib.js';
import React__default, { forwardRef, useState, useCallback, useEffect } from 'react';
import { ButtonWrapper, IconWrapper, Ripple } from './Button.css.js';

var Button = function (_a, refs) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onMouseDown = _a.onMouseDown, _c = _a.size, size = _c === void 0 ? 'md' : _c; _a.isOutline; var _e = _a.outline, outline = _e === void 0 ? 'solid' : _e, children = _a.children, style = _a.style, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.htmlType, htmlType = _g === void 0 ? 'button' : _g, _h = _a.isRounded, isRounded = _h === void 0 ? false : _h, _j = _a.isIcon, isIcon = _j === void 0 ? false : _j, _k = _a.isLightMode, isLightMode = _k === void 0 ? false : _k, _l = _a.iconPosition, iconPosition = _l === void 0 ? 'left' : _l, _m = _a.iconComponent, iconComponent = _m === void 0 ? null : _m, _o = _a.hasValueFilter, hasValueFilter = _o === void 0 ? false : _o, forResponsive = _a.forResponsive, rest = __rest(_a, ["type", "onClick", "onMouseEnter", "onMouseLeave", "onMouseDown", "size", "isOutline", "outline", "children", "style", "className", "htmlType", "isRounded", "isIcon", "isLightMode", "iconPosition", "iconComponent", "hasValueFilter", "forResponsive"]);
    var _p = useState({ x: -1, y: -1 }), coord = _p[0], setCoord = _p[1];
    var _q = useState(false), isRippling = _q[0], setRipping = _q[1];
    var typeClass = "btn-".concat(type);
    var sizeClass = size === 'lg'
        ? 'btn-lg'
        : size === 'md'
            ? 'btn-md'
            : size === 'md-h'
                ? 'btn-md-h'
                : size === 'sm'
                    ? 'btn-sm'
                    : 'btn-xs';
    var isClickable = type !== 'disabled' && !!onClick;
    var handleOnClick = useCallback(function (e) {
        // TODO: temporary disable Ripple effect due to un-consistent between reactjs project vs vanilla project
        // const rect = e.target.getBoundingClientRect()
        // setCoord({ x: e.clientX - rect.left, y: e.clientY - rect.top })
        onClick && onClick(e);
    }, [onClick]);
    useEffect(function () {
        if (coord.x !== -1 && coord.y !== -1) {
            setRipping(true);
            setTimeout(function () { return setRipping(false); }, 300);
        }
        else {
            setRipping(false);
        }
    }, [coord]);
    useEffect(function () {
        if (!isRippling)
            setCoord({ x: -1, y: -1 });
    }, [isRippling]);
    return (React__default.createElement(ButtonWrapper, __assign({ type: htmlType, buttonClass: type, buttonSize: size, isRounded: isRounded, isIcon: isIcon, outline: outline, isLightMode: isLightMode, className: "".concat(typeClass, " ").concat(sizeClass, " ").concat(className, " ").concat(isClickable ? 'clickable' : ''), onClick: handleOnClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseDown: onMouseDown, style: style, ref: refs, hasValueFilter: hasValueFilter, forResponsive: forResponsive }, rest),
        iconComponent && iconPosition === 'left' && React__default.createElement(IconWrapper, { isLeft: true }, iconComponent),
        children,
        iconComponent && iconPosition === 'right' && React__default.createElement(IconWrapper, { isLeft: false }, iconComponent),
        isRippling ? React__default.createElement(Ripple, { buttonClass: type, style: { left: coord.x, top: coord.y } }) : null));
};
var Button$1 = forwardRef(Button);

export { Button$1 as default };
//# sourceMappingURL=index.js.map
